import Main from "./Main";
import Default from "./Default";

export default {
  Main,
  Default
};
